import { Component, Input } from '@angular/core';
import { BaseComponent } from '../../base-components/base.component';
import { DocumentItemKeyData } from '../../models/document/document-itemkey.model';
import { DocumentSearchCriteria } from '../../models/document/document-search-criteria.model';

@Component({
    selector: 'document-retrieve-upload',
    templateUrl: './document-retrieve-upload.html'
})

export class DocumentRetriveUploadComponent extends BaseComponent {

    @Input() searchDocumentDataCollection: DocumentSearchCriteria[];
    @Input() minimalComponent = false;
    @Input() hideCloseButton = false;
    @Input() hideFilterOptions = false;
    @Input() hideColumnsForComplianceManagement = false;
    @Input() hideAddRequirement = false;
    @Input() hideAddDocuments = false;
    @Input() isViewOnly = false;

    public documentItemKeyCollection: DocumentItemKeyData[] = [];
    private documentCategoryCollection: number[] = [];
    public reLoadDocuments = true;

    constructor() {
        super();
    }

    ngOnInit() {
        for (var i = 0; i < this.searchDocumentDataCollection.length; i++) {
            if (this.searchDocumentDataCollection[i].itemKeyId && this.searchDocumentDataCollection[i].documentItemKeyTypeId) {
                var itemKeyData = new DocumentItemKeyData();
                itemKeyData.documentItemKeyTypeId = this.searchDocumentDataCollection[i].documentItemKeyTypeId;
                itemKeyData.itemKeyId = this.searchDocumentDataCollection[i].itemKeyId;
                this.documentItemKeyCollection.push(itemKeyData);
            }
            if (this.searchDocumentDataCollection[i].documentCategoryTypeId) {
                this.documentCategoryCollection.push(this.searchDocumentDataCollection[i].documentCategoryTypeId);
            }
        }
    }
}
